import React from 'react';
import { TeasingShell } from '../components/layout/TeasingShell';
import { Callout } from '../components/ui/Callout';
interface ConfidentialitateProps {
  navigate: (page: string) => void;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-3072">
      <h2 className="text-lg font-semibold text-light-1 mb-3" data-id="element-3073">{title}</h2>
      <div className="space-y-3" data-id="element-3074">{children}</div>
    </section>;
}
export function Confidentialitate({
  navigate
}: ConfidentialitateProps) {
  return <TeasingShell navigate={navigate} data-id="element-3075">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-3076">
        <h1 className="text-3xl sm:text-4xl font-bold text-light-1 mb-2" data-id="element-3077">
          Politica de Confidențialitate pentru pagina IZIO
        </h1>
        <p className="text-sm text-light-4 mb-12" data-id="element-3078">
          Ultima actualizare: 11 iunie 2026
        </p>

        <div className="space-y-10 text-light-2 text-sm leading-relaxed" data-id="element-3079">
          <Section title="1. Operatorul de date" data-id="element-3080">
            <p data-id="element-3081">
              Operatorul datelor dumneavoastră cu caracter personal în această
              etapă de prelucrare sunt inițiatorii proiectului Izio, acționând
              în calitate de persoane fizice în scopul dezvoltării și validării
              unui concept tehnologic (numiți în continuare „Operatorul” sau
              „noi”).
            </p>
            <Callout variant="tip" title="Context" data-id="element-3082">
              Această pagină web este o simplă listă de așteptare utilizată
              exclusiv pentru validarea unei idei de business și măsurarea
              interesului publicului. Colectăm un minim absolut de date — doar
              prenumele și adresa de e-mail — și le folosim exclusiv pentru a vă
              trimite invitația de acces la lansarea versiunii timpurii (Beta).
              În această etapă nu se creează niciun cont de utilizator.
            </Callout>
            <p data-id="element-3083">
              Pentru orice întrebări privind prelucrarea datelor personale, ne
              puteți contacta direct la: contact@izio.ro.
            </p>
          </Section>

          <Section title="2. Ce date colectăm" data-id="element-3084">
            <p data-id="element-3085">
              La înscrierea pe lista de așteptare ne furnizați în mod voluntar,
              prin intermediul formularului:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3086">
              <li data-id="element-3087">
                <strong className="text-light-1" data-id="element-3088">Prenumele</strong>
              </li>
              <li data-id="element-3089">
                <strong className="text-light-1" data-id="element-3090">Adresa de e-mail</strong>
              </li>
              <li data-id="element-3091">
                <strong className="text-light-1" data-id="element-3092">Tipul de utilizator</strong> pe
                care îl reprezentați (chiriaș, proprietar sau agent) — utilizat
                exclusiv pentru gruparea corectă a răspunsurilor în cadrul
                studiului de piață.
              </li>
            </ul>
            <p data-id="element-3093">
              <strong className="text-light-1" data-id="element-3094">Nu colectăm</strong> nume de
              familie, parole, copii ale actelor de identitate, date bancare,
              fotografii sau orice alte date sensibile.
            </p>
          </Section>

          <Section title="3. Scopul și temeiul juridic al prelucrării" data-id="element-3095">
            <p data-id="element-3096">
              Prelucrăm datele de mai sus pentru un singur scop reflectat de
              activitatea de cercetare:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3097">
              <li data-id="element-3098">
                Să vă anunțăm prin e-mail când versiunea timpurie a platformei
                devine disponibilă și să vă trimitem invitația de acces,
                împreună cu eventuale actualizări direct legate de evoluția
                proiectului.
              </li>
            </ul>
            <p data-id="element-3099">
              Temeiul juridic este{' '}
              <strong className="text-light-1" data-id="element-3100">
                consimțământul dumneavoastră explicit
              </strong>{' '}
              (Art. 6 alin. 1 lit. a din GDPR), exprimat prin acțiunea voluntară
              de înscriere pe listă și bifarea căsuței de accept. Vă puteți
              retrage acest consimțământ în orice moment (vezi secțiunea 7).
            </p>
          </Section>

          <Section title="4. Cui transmitem datele dumneavoastră" data-id="element-3101">
            <p data-id="element-3102">
              Pentru a gestiona lista de așteptare și a transmite e-mailurile,
              folosim un furnizor tehnic specializat în stocarea și trimiterea
              mesajelor, care acționează ca împuternicit:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3103">
              <li data-id="element-3104">
                <strong className="text-light-1" data-id="element-3105">
                  Loops (Loops Email, Inc., SUA)
                </strong>{' '}
                — platformă specializată utilizată ca împuternicit pentru
                stocarea securizată a listei de înscrieri și expedierea
                e-mailurilor. Prelucrarea datelor de către acest furnizor se
                desfășoară în conformitate cu{' '}
                <a href="https://loops.so/privacy" target="_blank" rel="noreferrer noopener" className="text-light-1 underline hover:text-lime-1 transition-colors" data-id="element-3106">
                  Politica de Confidențialitate Loops
                </a>{' '}
                și angajamentele de securitate standard ale acestuia.
              </li>
            </ul>
            <p data-id="element-3107">
              Nu transmitem datele către alți utilizatori și{' '}
              <strong className="text-light-1" data-id="element-3108">
                nu vindem, nu închiriem și nu cedăm datele dumneavoastră
              </strong>{' '}
              către terțe părți în scopuri comerciale sau publicitare. Le putem
              dezvălui autorităților publice doar dacă o obligație legală
              strictă ne cere acest lucru.
            </p>
          </Section>

          <Section title="5. Transferuri internaționale de date" data-id="element-3109">
            <p data-id="element-3110">
              Furnizorul nostru tehnic de e-mail (Loops) este stabilit în
              Statele Unite ale Americii. Transferul datelor către SUA se
              realizează în baza clauzelor contractuale standard aprobate de
              Comisia Europeană și a cadrului UE-SUA privind protecția datelor,
              asigurând un nivel de securitate echivalent celui din Uniunea
              Europeană.
            </p>
          </Section>

          <Section title="6. Durata de stocare a datelor și limitarea comercială" data-id="element-3111">
            <p data-id="element-3112">
              Datele introduse (prenumele, e-mailul) sunt păstrate pe lista de
              așteptare până la momentul lansării versiunii timpurii și
              trimiterii invitației de acces, sau până în momentul în care
              decideți să vă dezabonați. Dacă proiectul de cercetare nu se
              materializează, toate datele vor fi șterse definitiv.
            </p>
            <Callout variant="tip" title="Garanție viitoare" data-id="element-3113">
              În momentul în care proiectul va trece în faza comercială și va fi
              operat de o societate comercială (SRL), această bază de date nu va
              fi convertită automat în listă de marketing publicitar. Pentru
              transferul datelor în noua structură comercială sau includerea în
              fluxuri publicitare, veți primi o nouă cerere de aprobare prin
              e-mail. În lipsa unui nou acord din partea dvs., datele vor fi
              eliminate.
            </Callout>
          </Section>

          <Section title="7. Drepturile dumneavoastră" data-id="element-3114">
            <p data-id="element-3115">
              Conform Regulamentului General privind Protecția Datelor (GDPR),
              beneficiați de următoarele drepturi, pe care le puteți exercita
              simplu, printr-un e-mail trimis la contact@izio.ro:
            </p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3116">
              <li data-id="element-3117">
                <strong className="text-light-1" data-id="element-3118">Dreptul de acces</strong> (Art.
                15): Puteți solicita o confirmare și o copie a datelor pe care
                le deținem despre dvs.
              </li>
              <li data-id="element-3119">
                <strong className="text-light-1" data-id="element-3120">Dreptul la rectificare</strong>{' '}
                (Art. 16): Puteți solicita corectarea sau actualizarea adresei
                de e-mail sau a prenumelui.
              </li>
              <li data-id="element-3121">
                <strong className="text-light-1" data-id="element-3122">Dreptul la ștergere</strong>{' '}
                (Art. 17): Puteți solicita eliminarea definitivă din lista de
                așteptare în orice moment („dreptul de a fi uitat”).
              </li>
              <li data-id="element-3123">
                <strong className="text-light-1" data-id="element-3124">
                  Dreptul la restricționarea prelucrării
                </strong>{' '}
                (Art. 18) și{' '}
                <strong className="text-light-1" data-id="element-3125">Portabilitate</strong> (Art.
                20).
              </li>
              <li data-id="element-3126">
                <strong className="text-light-1" data-id="element-3127">
                  Dreptul de a retrage consimțământul
                </strong>{' '}
                (Art. 7): Vă puteți retrage acordul pentru e-mailuri în orice
                moment, fără a afecta legalitatea prelucrărilor făcute înainte
                de retragere.
              </li>
            </ul>
            <p data-id="element-3128">
              Vom răspunde oricărei solicitări legitime în termen de maximum 30
              de zile calendaristice.
            </p>
          </Section>

          <Section title="8. Module cookie" data-id="element-3129">
            <p data-id="element-3130">Această pagină folosește un sistem minim de module cookie:</p>
            <ul className="list-disc pl-6 space-y-1" data-id="element-3131">
              <li data-id="element-3132">
                <strong className="text-light-1" data-id="element-3133">Esențiale:</strong> Necesare
                din punct de vedere tehnic pentru funcționarea paginii și pentru
                a reține dacă ați acceptat sau respins alte module. Acestea nu
                pot fi dezactivate și nu necesită acord prealabil.
              </li>
              <li data-id="element-3134">
                <strong className="text-light-1" data-id="element-3135">Analitice (opționale):</strong>{' '}
                Ne ajută să măsurăm anonim numărul de vizitatori ai paginii.
                Acestea se activează doar dacă vă exprimați acordul prin
                bannerul dedicat.
              </li>
            </ul>
          </Section>

          <Section title="9. Securitatea datelor" data-id="element-3136">
            <p data-id="element-3137">
              Implementăm măsuri tehnice rezonabile pentru protejarea datelor,
              inclusiv criptarea conexiunii în tranzit (HTTPS/TLS) și stocarea
              lor pe o platformă specializată cu acces restricționat și
              securizat.
            </p>
          </Section>

          <Section title="10. Minori" data-id="element-3138">
            <p data-id="element-3139">
              Această pagină de testare nu se adresează persoanelor sub 18 ani.
              Nu colectăm cu bună știință date de la minori. Dacă descoperim o
              astfel de înregistrare eronată, o vom șterge imediat.
            </p>
          </Section>

          <Section title="11. Modificări ale Politicii" data-id="element-3140">
            <p data-id="element-3141">
              Putem actualiza această Politică pe măsură ce faza de validare a
              conceptului avansează. Versiunea actualizată va fi publicată
              direct pe site, schimbând data ultimei actualizări din antet.
            </p>
          </Section>

          <Section title="12. Plângeri" data-id="element-3142">
            <p data-id="element-3143">
              Dacă considerați că prelucrarea datelor dumneavoastră încalcă
              prevederile legale, aveți dreptul de a depune o plângere oficială
              la autoritatea de supraveghere:
            </p>
            <ul className="list-none space-y-1" data-id="element-3144">
              <li data-id="element-3145">
                <strong className="text-light-1" data-id="element-3146">
                  Autoritatea Națională de Supraveghere a Prelucrării Datelor cu
                  Caracter Personal (ANSPDCP)
                </strong>
              </li>
              <li data-id="element-3147">B-dul G-ral. Gheorghe Magheru 28-30, Sector 1, București</li>
              <li data-id="element-3148">
                E-mail: anspdcp@dataprotection.ro | Website:
                www.dataprotection.ro
              </li>
            </ul>
          </Section>

          <Section title="13. Contact" data-id="element-3149">
            <p data-id="element-3150">
              Pentru orice întrebări sau exercitarea drepturilor de ștergere, ne
              puteți contacta direct la:
            </p>
            <ul className="list-none space-y-1" data-id="element-3151">
              <li data-id="element-3152">Email: contact@izio.ro</li>
            </ul>
          </Section>
        </div>
      </div>
    </TeasingShell>;
}